export default __webpack_public_path__ + "e1227d67ada91ce6c55d0b02d9abe931.png";